import cssVars from 'css-vars-ponyfill'
import themeUtils from '../../util/themeUtils'

const home = {
  state: {
    siteInfo: null,
    loginRoleType: null
  },
  actions: {
    setSiteInfo (context, siteInfo) {
      const themeColor = '#24CC33'
      cssVars({
        variables: {
          '--theme-color': themeColor
        },
        watch: true,
        onlyLegacy: false,
        silent: true
      })
      themeUtils.changeTheme(themeColor)
      context.state.siteInfo = siteInfo
    },
    setLoginRoleType (context, type) {
      context.state.loginRoleType = type
    }
  }
}

export default home



// WEBPACK FOOTER //
// ./src/store/modules/home.js